import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pass-wrapper" }
const _hoisted_2 = { class: "pass-description" }
const _hoisted_3 = { class: "content absolute-fill" }

import GoldFrame from "@/components/Common/GoldFrame.vue";
import CardInfo from "@/components/RegistrationPage/Card/PcVersion/CardInfo.vue";
import CardBackground from "@/components/RegistrationPage/Card/PcVersion/CardBackground.vue";
import ToolTipStandartDescription from "@/components/Common/tooltip/ToolTipStandartDescription.vue";
import ToolTipWrapper from "@/components/Common/tooltip/ToolTipWrapper.vue";

import {defineComponent, PropType} from 'vue'
import store from "@/store";
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";

const __default__ = defineComponent({
    name: 'WhitePassCard',

    data(): {
        tilt: {
            x: number
            y: number
        },

        targetTilt: {
            x: number
            y: number
        },

        scale: number

        interval: number | null

        lineHighlightInverval: number | null
        lines: number
        highlightedLineIndex: number
    } {
        return {
            tilt: {
                x: 0,
                y: 0,
            },

            targetTilt: {
                x: 0,
                y: 0,
            },

            scale: 1.24,
            interval: null,

            lineHighlightInverval: null as unknown as number | null,
            lines: 6,
            highlightedLineIndex: 0,
        }
    },

    props: {
        tiltAngle: {
            type: Number,
            default: 20,
        },

        pass: {
            type: Object as PropType<PassProperties>,
            required: true,
        },
    },

    methods: {
        onMouseMove(event: MouseEvent): void
        {
            if (this.pageWidth <= store.state.mobileVersionThresholdWidth) return

            const box = this.$refs.box
            if (box instanceof HTMLDivElement) {
                this.targetTilt.x = this.tiltAngle * ( 2 * event.offsetX / box.clientWidth - 1)
                this.targetTilt.y = - this.tiltAngle * ( 2 * event.offsetY / box.clientHeight - 1)
            }
        },

        onMouseLeave(): void
        {
            if (this.pageWidth <= store.state.mobileVersionThresholdWidth) return

            this.targetTilt.x = 0
            this.targetTilt.y = 0
        },

        onClick(): void
        {
            store.state.selectedPass = this.pass
        },

        createInterval(): void
        {
            this.scale = 1
            if (this.interval) {
                this.tilt.x = 0
                this.tilt.y = 0

                clearInterval(this.interval)
            }

            if (this.pageWidth <= store.state.mobileVersionThresholdWidth) return

            this.scale = 1.25
            this.interval = setInterval(() => {
                const deltaX = Math.abs(this.targetTilt.x - this.tilt.x)
                if (deltaX < 0.001) {
                    this.tilt.x = this.targetTilt.x
                } else {
                    this.tilt.x += (this.targetTilt.x - this.tilt.x) / 50
                }

                const deltaY = Math.abs(this.targetTilt.y - this.tilt.y)
                if (deltaY < 0.001) {
                    this.tilt.y = this.targetTilt.y
                } else {
                    this.tilt.y += (this.targetTilt.y - this.tilt.y) / 50
                }
            })
        },

        stopHighlight(): void
        {
            if (this.lineHighlightInverval) {
                clearInterval(this.lineHighlightInverval)

                this.lineHighlightInverval = null
            }
        },
        
        startHighlight(): void
        {
            this.stopHighlight()

            this.lineHighlightInverval = setInterval(
                () => {
                    this.highlightedLineIndex++

                    if (this.highlightedLineIndex > this.lines) {
                        this.highlightedLineIndex = 0
                    }
                },
                1000,
            )
        },
        
    },

    mounted(): void
    {
        this.createInterval()

        this.startHighlight()
    },

    unmounted() {
        this.stopHighlight()
    },

    computed: {
        pageWidth(): number
        {
            return store.state.pageSize.width
        },
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

_useCssVars(_ctx => ({
  "48519e86": (_ctx.scale)
}))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[29] || (_cache[29] = _createElementVNode("img", {
      class: "noselect white_bg",
      draggable: "false",
      src: `/img/page/landing/registration/pass/white_pass/white_bg.png`
    }, null, -1)),
    _cache[30] || (_cache[30] = _createElementVNode("img", {
      class: "noselect ship",
      draggable: "false",
      src: `/img/page/landing/registration/pass/white_pass/ship.png`
    }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          class: _normalizeClass({active: _ctx.highlightedLineIndex === 1 && _ctx.lineHighlightInverval !== null}),
          onMousemove: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stopHighlight && _ctx.stopHighlight(...args))),
          onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startHighlight && _ctx.startHighlight(...args)))
        }, [
          _createVNode(ToolTipWrapper, null, {
            component: _withCtx(() => _cache[15] || (_cache[15] = [
              _createTextVNode(" Анимированная голограмма корабля ")
            ])),
            tooltip: _withCtx(() => [
              _createVNode(ToolTipStandartDescription, null, {
                default: _withCtx(() => _cache[16] || (_cache[16] = [
                  _createElementVNode("div", { class: "d-flex flex-column gap-1 fs-rem-10" }, [
                    _createElementVNode("span", null, [
                      _createTextVNode("Пропуск «Элита Федерации» - единственный пропуск, включающий обалденную анимированную голограмму корпуса "),
                      _createElementVNode("span", { class: "text-wheat font-furore" }, "«Альфа»")
                    ])
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ], 34),
        _createElementVNode("li", {
          class: _normalizeClass({active: _ctx.highlightedLineIndex === 2 && _ctx.lineHighlightInverval !== null}),
          onMousemove: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stopHighlight && _ctx.stopHighlight(...args))),
          onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.startHighlight && _ctx.startHighlight(...args)))
        }, [
          _createVNode(ToolTipWrapper, null, {
            component: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode(" Самое большое число галакоинов ")
            ])),
            tooltip: _withCtx(() => [
              _createVNode(ToolTipStandartDescription, null, {
                default: _withCtx(() => _cache[18] || (_cache[18] = [
                  _createElementVNode("div", { class: "d-flex flex-column gap-1 fs-rem-10" }, [
                    _createElementVNode("span", null, "Пропуск включает колоссальное количество внутриигровой донатной валюты!")
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ], 34),
        _createElementVNode("li", {
          class: _normalizeClass({active: _ctx.highlightedLineIndex === 3 && _ctx.lineHighlightInverval !== null}),
          onMousemove: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.stopHighlight && _ctx.stopHighlight(...args))),
          onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.startHighlight && _ctx.startHighlight(...args)))
        }, [
          _createVNode(ToolTipWrapper, null, {
            component: _withCtx(() => _cache[19] || (_cache[19] = [
              _createTextVNode(" Стильная кастомизация профиля ")
            ])),
            tooltip: _withCtx(() => [
              _createVNode(ToolTipStandartDescription, null, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createElementVNode("div", { class: "d-flex flex-column gap-1 fs-rem-10" }, [
                    _createElementVNode("span", null, "Аватарка и рамка из этого пропуска - настоящие произведения искусства!")
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ], 34),
        _createElementVNode("li", {
          class: _normalizeClass({active: _ctx.highlightedLineIndex === 4 && _ctx.lineHighlightInverval !== null}),
          onMousemove: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.stopHighlight && _ctx.stopHighlight(...args))),
          onMouseleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.startHighlight && _ctx.startHighlight(...args)))
        }, [
          _createVNode(ToolTipWrapper, null, {
            component: _withCtx(() => _cache[21] || (_cache[21] = [
              _createTextVNode(" Бонусы всех других пропусков ")
            ])),
            tooltip: _withCtx(() => [
              _createVNode(ToolTipStandartDescription, null, {
                default: _withCtx(() => _cache[22] || (_cache[22] = [
                  _createElementVNode("div", { class: "d-flex flex-column gap-1 fs-rem-10" }, [
                    _createElementVNode("span", null, [
                      _createTextVNode("Пропуск "),
                      _createElementVNode("span", { class: "text-wheat font-furore" }, "«Элита Федерации»"),
                      _createTextVNode(" включает в себя бонусы из всех других пропусков: аватарки, рамки, голограммы корпусов и дополнительные шмотки")
                    ])
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ], 34),
        _createElementVNode("li", {
          class: _normalizeClass({active: _ctx.highlightedLineIndex === 5 && _ctx.lineHighlightInverval !== null}),
          onMousemove: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.stopHighlight && _ctx.stopHighlight(...args))),
          onMouseleave: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.startHighlight && _ctx.startHighlight(...args)))
        }, [
          _createVNode(ToolTipWrapper, null, {
            component: _withCtx(() => _cache[23] || (_cache[23] = [
              _createTextVNode(" Вечные подписки на бусты ")
            ])),
            tooltip: _withCtx(() => [
              _createVNode(ToolTipStandartDescription, null, {
                default: _withCtx(() => _cache[24] || (_cache[24] = [
                  _createElementVNode("div", { class: "d-flex flex-column gap-1 fs-rem-10" }, [
                    _createElementVNode("span", null, [
                      _createTextVNode("Все возможные "),
                      _createElementVNode("span", { class: "text-wheat font-furore" }, "вечные предактивированные бусты"),
                      _createTextVNode(" - главная фича пропуска!")
                    ]),
                    _createElementVNode("span", null, "Бусты - это ежемесячные подписки, помогающие в разных игровых аспектах. К счастью, тебе никогда не придётся задумываться о том, чтобы их покупать или вовремя продлевать. Ведь ты - счастливый обладатель всех доступных бустов, причём с неограниченным сроком действия!"),
                    _createElementVNode("span", null, "Набор включает бусты опыта, майнинга, зондирования, крафта, ремонта и все остальные бусты, доступные в игре.")
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ], 34),
        _createElementVNode("li", {
          class: _normalizeClass({active: _ctx.highlightedLineIndex === 6 && _ctx.lineHighlightInverval !== null}),
          onMousemove: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.stopHighlight && _ctx.stopHighlight(...args))),
          onMouseleave: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.startHighlight && _ctx.startHighlight(...args)))
        }, [
          _createVNode(ToolTipWrapper, null, {
            component: _withCtx(() => _cache[25] || (_cache[25] = [
              _createTextVNode(" Артефакт «Катализатор» ")
            ])),
            tooltip: _withCtx(() => [
              _createVNode(ToolTipStandartDescription, null, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createElementVNode("div", { class: "d-flex flex-column gap-1 fs-rem-10" }, [
                    _createElementVNode("span", null, [
                      _createElementVNode("span", { class: "text-wheat font-furore" }, "Катализатор"),
                      _createTextVNode(" - редкий артефакт, значительно облегчающий жизнь. Помещённый в топливный бак, катализатор постепенно увеличивает количество топлива. Проблема экстренной дозаправки никогда не застанет тебя врасплох!")
                    ])
                  ], -1)
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ], 34)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["passCard noselect", {
                active: _ctx.pass === _unref(store).state.selectedPass,
            }]),
      onMousemove: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.onMouseMove && _ctx.onMouseMove(...args))),
      onMouseleave: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onMouseLeave && _ctx.onMouseLeave(...args))),
      onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
      ref: 'box',
      style: _normalizeStyle({
                transform: `perspective(1000px) rotateY(${_ctx.tilt.x}deg) rotateX(${_ctx.tilt.y}deg)`,
            })
    }, [
      _createVNode(GoldFrame, {
        offset: 0,
        "size-modifier": 0.5
      }),
      _cache[27] || (_cache[27] = _createElementVNode("img", {
        class: "noselect stars",
        draggable: "false",
        src: `/img/page/landing/registration/pass/white_pass/stars.png`
      }, null, -1)),
      _cache[28] || (_cache[28] = _createElementVNode("img", {
        class: "face",
        alt: "",
        src: `/img/page/landing/registration/avatar/white_pass/body.png`
      }, null, -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CardBackground, {
          tilt: _ctx.tilt,
          "tilt-angle": _ctx.tiltAngle,
          pass: _ctx.pass,
          "bg-url": `white_pass_1.jpg`
        }, null, 8, ["tilt", "tilt-angle", "pass"]),
        _createVNode(CardInfo, {
          pass: _ctx.pass,
          style: {"font-family":"Furore !important"}
        }, null, 8, ["pass"])
      ])
    ], 38)
  ]))
}
}

})